import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PillComponent } from '../../pills/pill/pill.component';

@Component({
  selector: 'app-table-filter-pills',
  standalone: true,
  imports: [NgIf, PillComponent],
  templateUrl: './table-filter-pills.component.html',
  styleUrls: ['./table-filter-pills.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableFilterPillsComponent {
  @Input() activeFiltersCount: number = 0;
  @Input() activeSearchCount: number = 0;
  @Input() showingFilterWindow: boolean = false;
  @Input() disabled: boolean = false;
  @Output() searchPillClicked = new EventEmitter<void>();
  @Output() filterPillClicked = new EventEmitter<void>();
}
